import { Injectable } from '@angular/core';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { CommonHttpsService } from '../../../../core/services/https/common-https.service';
import { ToasterMessageService } from '../../../../core/services/topbar-toaster/toaster-message.service';
import { GlobalService } from '../../../../core/services/common/global.service';
import { HttpHeaders } from '@angular/common/http';
import { headers } from '../../../../core/common/headers';
import { apiUrls } from '../../../../core/common/api_urls/api_urls';
import { catchError, tap, throwError } from 'rxjs';
import { errorMessage } from '../../../../core/common/language/error';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CommunicationLogsService {
  public errorMessage = errorMessage;
  constructor(
    public loadingService: LoaderService,
    public commonHttpService: CommonHttpsService,
    public messageService: ToasterMessageService,
    public globalService: GlobalService,
  ) { }

  header = new HttpHeaders({
    [headers.careManagerHeader]: 'true',
  });
  commonHeader = new HttpHeaders({
    [headers.lookupHeader]: 'true',
  });

  getCommunicationLogs(practice: number | null, fromDate: string, toDate: string,type:string) {
    return this.commonHttpService
      .GetListwHead(
        apiUrls.caremanager.communicationLogs.geCommunicationLogs(
          practice,
          // 52,
          moment(fromDate).format('YYYY-MM-DD') || 'null',
          moment(toDate).format('YYYY-MM-DD') || 'null',
          type
        ),
        {
          headers: this.header,
        },
      )
      .pipe(
        tap((data) => { }),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          // this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  
  lockORUnlockPatient(poolId:number, action:string){
     return this.commonHttpService
      .AddEntity(
        apiUrls.caremanager.ivr.lockOrUnlockPatient(poolId,action),
        {},
        {
          headers: this.commonHeader,
        },
        false,
      )
      .pipe(
        tap((message) => {
          this.loadingService.stopSpinner();
        }),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }

  getIncomingCalls() {
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .GetListwHead(
        apiUrls.caremanager.ivr.get,
        {
          headers: headerss,
        },
      )
      .pipe(
        tap((data) => { }),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  getCounts() {
    // This is polled on an interval in the background and never shows the
    // shared spinner (showSpinner() is intentionally not called here), so it
    // must not stop it either. An unmatched stopSpinner() here decrements
    // the shared request counter and can hide the overlay early for a
    // genuinely still-pending, unrelated request elsewhere (e.g. after-call
    // summary generation) if this poll happens to land while that's in flight.
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .GetListwHead(
        apiUrls.caremanager.ivr.getCount,
        {
          headers: headerss,
        },
      )
      .pipe(
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          return throwError(() => error);
        }),
      );
  }
  getCallSummary(patientId:number,sid:string) {
    this.loadingService.showSpinner();
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .GetByIdwHead(
        apiUrls.caremanager.ivr.getSummary(patientId,sid),
        headerss
        
      )
      .pipe(
        tap((data) => {this.loadingService.stopSpinner() }),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  getLiveCallSummary(
    patientId: number,
    ivrSelection: string | number,
    responseTime: string | number,
    username: string,
    callerName: string,
    confSid: string,
    callDateAndTime: string,
  ) {
    this.loadingService.showSpinner();
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .GetByIdwHead(
        apiUrls.caremanager.ivr.getLiveSummary(
          patientId,
          ivrSelection,
          responseTime,
          username,
          callerName,
          confSid,
          callDateAndTime,
        ),
        headerss,
      )
      .pipe(
        tap((data) => { this.loadingService.stopSpinner() }),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  saveGeneratedSummary(body:any) {
    debugger
    this.loadingService.showSpinner();
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .AddEntity(
        apiUrls.caremanager.ivr.saveCallSummary,body,
        {
          headers: headerss,
        },
      )
      .pipe(
        tap((data) => { this.loadingService.stopSpinner();}),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  escalateToNp(body:any) {
    this.loadingService.showSpinner();
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .AddEntity(
        apiUrls.caremanager.ivr.escalateTONp,body,
        {
          headers: headerss,
        },
      )
      .pipe(
        tap((data) => { this.loadingService.stopSpinner();}),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  saveClearSummary(queue_id:number,notes:string) {
    this.loadingService.showSpinner();
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .PatchEntity(
        apiUrls.caremanager.ivr.clearQueue(queue_id,notes),null,
        {
          headers: headerss,
        },
      )
      .pipe(
        tap((data) => { this.loadingService.stopSpinner();}),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
  makeResolvedAndComplete(body:any) {
    debugger
    this.loadingService.showSpinner();
    let headerss = new HttpHeaders({
      [headers.lookupHeader]: 'true',
    });
    return this.commonHttpService
      .UpdateEntity(
        apiUrls.caremanager.ivr.resolvedSummary,body,
        {
          headers: headerss,
        },
      )
      .pipe(
        tap((data) => { this.loadingService.stopSpinner();}),
        catchError((error: any) => {
          this.messageService.errroMessage(
            this.errorMessage.ERRORMESSAGE,
            true,
          );
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }
}
export interface LatestTypedInteraction {
  notes: string | null;
}

export interface LatestAnyInteraction {
  interaction_type_id: number;
  notes: string | null;
}

export interface QueueAssignment {
  cognito_user_id: string;
  user_name: string;
  assignment_source: string;
}
export interface Tag {
  name: string;
  priority: string;
}

export interface ContextCard {
  notes: string | null;
  interaction_type_name: string | null;
  user: string | null;
  date: string | null; // Keeps ISO timestamp format as string
}

export interface PatientSafetyFlag {
  notes: string | null;
  interaction_type_name: string | null;
  user: string | null;
  date: string | null;
}

export interface Program {
  program_id: number;
  program_name: string;
}

export interface ClinicPractice {
  clinic_id: number;
  clinic_name: string;
  practice_id: number;
  practice_name: string;
}

export interface Assignment {
  user_id: number | null;
  cognito_user_id: string | null;
  user_name: string | null;
  assignment_source: string | null;
}

export interface EscalationRoute {
  current: string | null;
  previous: string | null;
}

export interface EscalationLog {
  user_id: string | null;
  user_name: string | null;
  user_type_id: number | null;
  reason: string | null;
  date: string | null;
}

// Main Interface wrapping the array payload
export interface PatientQueueItem {
  queue_id: number;
  patient_id: number;
  first_name: string;
  last_name: string;
  doctor_first_name: string;
  doctor_last_name: string;
  dob: string;
  phone_number: string;
  doctor_phone: string;
  land_line_num: string;
  interaction_type_id: number;
  sid: string;
  relationship_with_patient: string;
  is_matched: boolean;
  call_datetime: string;
  ivr_selection: number;
  priority: 'P1' | 'P2' | 'P3' | string; // Use union types for strict priority matching
  tags: Tag[];
  status: 'Pending' | 'Completed' | 'In Progress' | string;
  bot_patient_summary: string;
  bot_patient_transcript: string;
  is_after_hour: boolean;
  time_in_queue: string;
  created_on: string;
  super_admin:boolean;
  context_card: ContextCard;
  patient_safety_flag: PatientSafetyFlag;
  state_id: number;
  state_name: string;
  is_locked: boolean;
  locked_by_userid: number | null;
  locked_by_name: string | null;
  programs: Program[];
  twilio_numbers: twilioDetail[];
  doctor_twilio_numbers: twilioDetail[];
  clinic_practice: ClinicPractice[];
  assignment: Assignment;
  escalation_route: EscalationRoute;
  escalation_logs: EscalationLog[];
}
export interface EscaltionRoute{
  current:string | null;
  previous:string | null;
}
export interface twilioDetail{
  clinicprogramid:number |0;
  number:string | "";
}
